import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Layout/Breadcrumb";

import FormStep3 from "./FormStep3";
import { useParams } from "react-router-dom";

const Edit = () => {
  const { id, immigration_id } = useParams();
  const { t } = useTranslation();

  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
    },
    {
      url: "/immigration/list",
      label: t("List view"),
      active: false,
    },
    {
      url: "#",
      label: `${t("Update")} ${t("immigration")}`,
      active: true,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbTitle={`${t("Immigration Details")}`}
            breadcrumbItems={breadcrumbItems}
          />
          <FormStep3 id={id} immigration_id={immigration_id} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Edit;